const breakpoints = {
  values: { xs: 0, sm: 376, md: 744, lg: 1326, xl: 1880 },
};

export default breakpoints;
